module.exports = __webpack_public_path__ + "assets/images/premium-circle@2x-b55b0656208466c3d7d27710a6f1a0a2.png";